module.exports = __webpack_public_path__ + "static/media/job_domestic_type.174da5b0.svg";